export interface IColumnSetting {
    columnOrder?: number;
    columnName?: string;
    visible?: boolean;
    columnWidth?: number;
}


export interface ColumnSettingsParam {
    values: IColumnSetting[];
};

const serializeColumnSettingsParam = (param?: ColumnSettingsParam | null) => {
    if (param === undefined || param === null) {
        return null;
    }

    let result: string[] = [];
    for (var columnSetting of param.values) {
        result.push(`${columnSetting.columnName},${columnSetting.columnOrder},${columnSetting.visible}`);
    }

    return result.join(';');
}



export { serializeColumnSettingsParam };